export default __webpack_public_path__ + "static/media/plus.8c8e936d.svg";